import { render, staticRenderFns } from "./Categorias.vue?vue&type=template&id=675a3a24&scoped=true&"
import script from "./Categorias.vue?vue&type=script&lang=ts&"
export * from "./Categorias.vue?vue&type=script&lang=ts&"
import style0 from "./Categorias.vue?vue&type=style&index=0&id=675a3a24&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675a3a24",
  null
  
)

export default component.exports